import { Flex, Icon, IconProps, Tooltip, TooltipContent, TooltipProps, TooltipTrigger } from '@alpine-iq/ui-library';
import React from 'react';

type HelpTooltipProps = Partial<IconProps> & {
	tooltip: string | React.ReactNode;
	tooltipProps?: TooltipProps & {
		style?: React.CSSProperties;
	};
	children?: React.ReactNode;
};

export default function HelpTooltip({ tooltip, tooltipProps, children, ...props }: HelpTooltipProps) {
	return (
		<>
			<Tooltip>
				<TooltipTrigger asChild>
					{children || (
						<Flex align="center">
							<Icon
								type="HELP"
								color="var(--text-secondary)"
								height={16}
								width={16}
								{...props}
							/>
						</Flex>
					)}
				</TooltipTrigger>
				<TooltipContent
					{...tooltipProps}
					style={{
						zIndex: 999999,
						maxWidth: 300,
						...tooltipProps?.style,
					}}
				>
					{tooltip}
				</TooltipContent>
			</Tooltip>
		</>
	);
}
